.container {
  flex: 1;
  width: 100%;
}

.iframeHidden {
  display: none;
}

.iframeVisible {
  display: block;
}
